<template>
<div>
  <div :id="`map-preview-${id}`" class="map-preview" style='width: 100%; height: 100%; min-height:300px; min-width:300px;'></div>
</div>
</template>

<script>
// Map preview component
// Renders the marker radius on a map
// Not interactive, but auto-updates based on the position prop value

import L from 'leaflet'
import debounce from 'lodash.debounce'

const mapboxUrl = 'https://api.mapbox.com/styles/v1/philippe-look/cisadedxf003i2zo3t5ruhi23/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGhpbGlwcGUtbG9vayIsImEiOiJjaXNhZDl3aHQwMDJjMnVwNWtibDR2azBvIn0.rT49BllHbiANRj9yQL0ozQ'

var circleOptions = {
  stroke: true,
  color: '#ff2d55',
  weight: 2,
  dashArray: '6, 6',
  opacity: 1,
  fill: true,
  fillColor: '#ff2d55',
  fillOpacity: 0.1,
  clickable: false
}

export default {
  props: [
    'position'
  ],
  data: function () {
    return {
      id: this._uid
    }
  },
  mounted: function () {
    this.mapUpdateHandler = debounce(this.updateMapPreview, 200)
    this.setupMapPreview(this.position.lat, this.position.long, this.position.radius)
  },
  watch: {
    position: function () {
      this.mapUpdateHandler()
    }
  },
  methods: {
    setupMapPreview: function (lat, long, radius) {
      var mapPreview = L.map(`map-preview-${this.id}`, {zoomControl: false, attributionControl: false})
        .setView([lat, long], 13)
      addMapboxLayerTo(mapPreview)
      disableMapControls(mapPreview)
      var circle = L.circle([lat, long], radius, circleOptions).addTo(mapPreview)
      this.mapPreview = {}
      this.mapPreview.leaflet = mapPreview
      this.mapPreview.circle = circle
      this.mapUpdateHandler()
    },
    updateMapPreview: function () {
      this.mapPreview.circle.setLatLng([this.position.lat, this.position.long])
      this.mapPreview.circle.setRadius(this.position.radius)
      if (this.position.initial) {
        this.mapPreview.circle.setStyle({opacity: 0})
        this.mapPreview.leaflet.fitWorld().zoomIn()
      } else {
        this.mapPreview.circle.setStyle({opacity: 1})
        this.mapPreview.leaflet.fitBounds(
          this.mapPreview.circle.getBounds(), {padding: [50, 50]}
        )
      }
    }
  }
}

function disableMapControls (mapHandle) {
  mapHandle._handlers.forEach(function (handler) {
    handler.disable()
  })
}

function addMapboxLayerTo (mapHandle) {
  L.tileLayer(mapboxUrl).addTo(mapHandle)
}
</script>
